export default __webpack_public_path__ + "static/media/brodinski_feat_bloody_jay_2_lowdef.88fc669b.png";